export default (function () {
    var host = window.location.host;
    if (/-dev|dev\./.test(host))
        return 'dev';
    if (/-fat|fat\./.test(host))
        return 'fat';
    if (/-stage|stage\./.test(host))
        return 'stage';
    return 'prod';
});
